/* istanbul ignore file */

import Player from 'video.js/dist/types/player';

import {
  triggerAdClicked,
  triggerAdEnded,
  triggerAdPlay,
} from './ad-event-triggers';
import { AdCuePoint, AdObject, AdPluginSettings, AdType } from './ad-types';

/**
 * Starts a banner ad and place it in the player
 * register the appropriate triggers to handle the lifecycle of the ad.
 * @param player The player instance
 * @param ad The ad object to play
 * @param settings Settings passed to the ad plugin
 */
export function playImageAd(
  player: any,
  source: AdType,
  adCue: AdCuePoint,
  ad: AdObject,
  settings: AdPluginSettings
) {
  if (!ad.images) {
    return;
  }
  const thingsToCleanUp = [] as HTMLElement[];
  const triggersToDisconnect = [] as {
    type: string;
    fn: (...args: any[]) => any;
  }[];
  const image = ad.images[0];
  const hideAfter = (ad.displayDuration || 10) * 1000;
  let suppressAdsEvent = false;

  const bannerContainer = document.createElement('div');
  bannerContainer.className = 'banner-ad';
  bannerContainer.innerHTML = [
    image.href
      ? `<a class="cta" href="${image.href}" target='${
          ad.target || '_blank'
        }'><img src='${image.src}'></a>`
      : `<img class="" src='${image.src}'>`,
    '<span class="ad-text">Advertisement</span>',
  ].join('\n');
  player.el().appendChild(bannerContainer);
  thingsToCleanUp.push(bannerContainer);

  triggerAdPlay(player, source, adCue, ad, image.fileName);

  if (image.href) {
    (bannerContainer.querySelector('a.cta') as HTMLAnchorElement).onclick =
      () => {
        player.pause();
        if (!suppressAdsEvent) {
          triggerAdClicked(player, source, adCue, ad, image.fileName);
          suppressAdsEvent = true;
        }
        exitAd(player, thingsToCleanUp, triggersToDisconnect);
      };
  }

  player.setTimeout(() => {
    if (!suppressAdsEvent) {
      triggerAdEnded(player, source, adCue, ad, image.fileName);
      suppressAdsEvent = true;
    }
    exitAd(player, thingsToCleanUp, triggersToDisconnect);
  }, hideAfter);

  player.trigger('adscanceled');
}

function exitAd(
  player: Player,
  thingsToCleanUp: HTMLElement[],
  triggersToDisconnect: { type: string; fn: (...a: any[]) => any }[]
) {
  thingsToCleanUp.forEach((el) => el.parentNode?.removeChild(el));
  triggersToDisconnect.forEach(({ type, fn }) => {
    player.off(type, fn);
  });
}
